import {library} from "@fortawesome/fontawesome-svg-core"
import {faAt, faCog, faDollarSign, faLock, faPhone, faPlus, faSearch, faTrash} from "@fortawesome/free-solid-svg-icons"

export default function registerIcons() {
    library.add(
        faPhone,
        faAt,
        faDollarSign,
        faLock,
        faPlus,
        faTrash,
        faSearch,
        faCog,
    );
}
